import styles from '@ui/components/Voting/components/Toggle/Toggle.module.scss';
import Heading from '@ui/components/Heading/Heading';
import Toggle from '@ui/components/Toggle/Toggle';
import Result from '@ui/components/Voting/components/Result/Result';
import React, { useEffect, useState } from 'react';
import { useRadioStore } from '@ariakit/react';
import PropTypes from 'prop-types';

const ToggleComponent = ({
  answers,
  id,
  onSubmitValue,
  question,
  results = null,
}) => {
  const [value, setValue] = useState();
  const radio = useRadioStore({ value, setValue });
  const headingId = `${id}-${question}`;

  useEffect(() => {
    if (value) {
      onSubmitValue('toggle', value);
    }
  }, [value]);

  return results ? (
    <Result question={question} results={results} selectedIndex={value - 1} />
  ) : (
    <>
      <Heading
        align="center"
        as="div"
        className={styles.question}
        id={headingId}
        size="h4"
      >
        {question}
      </Heading>
      <Toggle
        ariaLabelledBy={headingId}
        firstLabel={answers[0]}
        id={id}
        secondLabel={answers[1]}
        store={radio}
      />
    </>
  );
};

ToggleComponent.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.string.isRequired,
  onSubmitValue: PropTypes.func.isRequired,
  question: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      percentage: PropTypes.number,
    }),
  ),
};

export default ToggleComponent;
